import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { screenNames } from './screenNames';
import { AppbarScreenOptions, DefaultModalOptions, DefaultScreenOptions } from '../components/NavigatorAppbar';
import { useI18n } from '../context/I18nContext';
import { SubscriptionsRouteParams, SubscriptionsScreen } from '../screens/Subscriptions/SubscriptionsScreen';
import {
  SubscriptionDetailScreen,
  SubscriptionDetailRouteParams,
} from '../screens/Subscriptions/SubscriptionDetailScreen';
import SelectPaymentMethod from '../payment/screens/SelectPaymentMethod';
import { SpaceInfo, SpaceInfoRouteParams } from '../screens/SpaceInfo';
import {
  ConfirmSubscriptionDialog,
  ConfirmSubscriptionDialogRouteParams,
} from '../screens/Subscriptions/ConfirmSubscriptionDialog';
import {
  ConfirmSubscriptionCancelDialog,
  ConfirmSubscriptionCancelDialogRouteParams,
} from '../screens/Subscriptions/ConfirmSubscriptionCancelDialog';
import OnlinePage, { OnlinePageRouteParams } from '../screens/OnlinePage';
import AddThirdPartyAuth from '../screens/UpdateProfile/AddThirdPartyAuth';
import ThirdPartyAuthWebView, { ThirdPartyAuthWebViewRouteParams } from '../screens/ThirdPartyAuthWebView';
import { ThirdPartyAuthDetail, ThirdPartyAuthDetailRouteParams } from '../screens/UpdateProfile/ThirdPartyAuthDetail';

export type SubscriptionsStackRouteParams = {
  [screenNames.SubscriptionsScreen]: SubscriptionsRouteParams;
  [screenNames.SubscriptionDetailScreen]: SubscriptionDetailRouteParams;
  [screenNames.PaymentChangeBeforeCheckoutView]: undefined;
  [screenNames.AddThirdPartyAuth]: undefined;
  [screenNames.ThirdPartyAuthWebView]: ThirdPartyAuthWebViewRouteParams;
  [screenNames.ThirdPartyAuthDetail]: ThirdPartyAuthDetailRouteParams;
  [screenNames.ConfirmSubscriptionDialog]: ConfirmSubscriptionDialogRouteParams;
  [screenNames.ParkingTerms]: OnlinePageRouteParams | undefined;
  [screenNames.ConfirmSubscriptionCancelDialog]: ConfirmSubscriptionCancelDialogRouteParams;
  [screenNames.SpaceInfo]: SpaceInfoRouteParams;
};

const Stack = createStackNavigator<SubscriptionsStackRouteParams>();

export default function SubscriptionsStackNavigator() {
  const { I18n } = useI18n();

  return (
    <Stack.Navigator initialRouteName={screenNames.SubscriptionsScreen} screenOptions={DefaultScreenOptions}>
      <Stack.Screen
        name={screenNames.SubscriptionsScreen}
        component={SubscriptionsScreen}
        options={{
          title: I18n.t('subscriptions.title'),
        }}
      />
      <Stack.Screen
        name={screenNames.SubscriptionDetailScreen}
        component={SubscriptionDetailScreen}
        options={{
          title: I18n.t('subscriptions.detail.title'),
        }}
      />
      <Stack.Screen
        name={screenNames.PaymentChangeBeforeCheckoutView}
        component={SelectPaymentMethod}
        options={{
          ...DefaultScreenOptions,
          title: I18n.t('payment.changePayment'),
        }}
      />

      <Stack.Screen
        name={screenNames.AddThirdPartyAuth}
        component={AddThirdPartyAuth}
        options={{
          ...DefaultScreenOptions,
          title: I18n.t('thirdPartyAuth.add.headerTitle'),
        }}
      />
      <Stack.Screen
        name={screenNames.ThirdPartyAuthWebView}
        component={ThirdPartyAuthWebView}
        options={AppbarScreenOptions}
      />

      <Stack.Screen
        name={screenNames.ThirdPartyAuthDetail}
        component={ThirdPartyAuthDetail}
        options={{
          ...AppbarScreenOptions,
          title: I18n.t('thirdPartyAuth.headerTitle'),
        }}
      />

      <Stack.Screen
        name={screenNames.ConfirmSubscriptionDialog}
        component={ConfirmSubscriptionDialog}
        options={DefaultModalOptions}
      />
      <Stack.Screen name={screenNames.ParkingTerms} component={OnlinePage} options={AppbarScreenOptions} />
      <Stack.Screen
        name={screenNames.ConfirmSubscriptionCancelDialog}
        component={ConfirmSubscriptionCancelDialog}
        options={DefaultModalOptions}
      />
      <Stack.Screen
        name={screenNames.SpaceInfo}
        component={SpaceInfo}
        options={{
          ...DefaultScreenOptions,
          title: I18n.t('mapview.spaceInfo.headerTitle'),
        }}
      />
    </Stack.Navigator>
  );
}
